import { Injectable, isDevMode } from '@angular/core';
import { EMPTY, Subject } from 'rxjs';
import { ReportsTurnsDaoService } from 'src/app/dao/turns-dao-services/reports-turns-dao-service/reports-turns-dao.service';
import { FormGroup } from '@angular/forms';
import { TurnReportBasic } from 'src/app/models/turns-models/turns-report-basic.model';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { UserService } from '../../user-service/user.service';
import { DashboardDaoService } from 'src/app/dao/dashboard-dao-service/dashboard-dao.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsTurnsService {

  accessToken = ['DHT', 'TUR', 'CTR', 'SAL'];
  filterReportsForm: FormGroup;
  statusList: string[];
  showAdvanced: boolean;
  refreshReportsListListener = new Subject<any>();

  constructor(private reportsTurnsDaoService: ReportsTurnsDaoService,
              private dashboardDaoService: DashboardDaoService,
              private userService: UserService,
              private userStorageService: UserStorageService) { }

  public filterTurnsList(dateTimeFrom, dateTimeTo, centerInternalIdList, statusList, turnDeskInternalIdList) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsTurnsDaoService.filterTurnsList(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), dateTimeFrom, dateTimeTo, centerInternalIdList, statusList, turnDeskInternalIdList).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          o['data']['listTurnStadistics'].map((i) => {
            i['appTurnsCancelled'] === 0 ? i['appTurnsCancelled'] = '-' : i['appTurnsCancelled'] = i['appTurnsCancelled'];
            i['appTurnsPicked'] === 0 ? i['appTurnsPicked'] = '-' : i['appTurnsPicked'] = i['appTurnsPicked'];
            i['creationDate'] === 0 ? i['creationDate'] = '-' : i['creationDate'] = i['creationDate'];
            i['modificationDate'] === 0 ? i['modificationDate'] = '-' : i['modificationDate'] = i['modificationDate'];
            i['smsTurnsPicked'] === 0 ? i['smsTurnsPicked'] = '-' : i['smsTurnsPicked'] = i['smsTurnsPicked'];
            i['ticketTurnsPicked'] === 0 ? i['ticketTurnsPicked'] = '-' : i['ticketTurnsPicked'] = i['ticketTurnsPicked'];
            i['totalSmsSent'] === 0 ? i['totalSmsSent'] = '-' : i['totalSmsSent'] = i['totalSmsSent'];
            i['totalTurnsAttended'] === 0 ? i['totalTurnsAttended'] = '-' : i['totalTurnsAttended'] = i['totalTurnsAttended'];
            i['totalTurnsBacked'] === 0 ? i['totalTurnsBacked'] = '-' : i['totalTurnsBacked'] = i['totalTurnsBacked'];
            i['totalTurnsCancelled'] === 0 ? i['totalTurnsCancelled'] = '-' : i['totalTurnsCancelled'] = i['totalTurnsCancelled'];
            i['totalTurnsPassed'] === 0 ? i['totalTurnsPassed'] = '-' : i['totalTurnsPassed'] = i['totalTurnsPassed'];
            i['totalTurnsPicked'] === 0 ? i['totalTurnsPicked'] = '-' : i['totalTurnsPicked'] = i['totalTurnsPicked'];
            i['turnsWaitAverageSecs'] === 0 ? i['turnsWaitAverageSecs'] = '-' : i['turnsWaitAverageSecs'] = i['turnsWaitAverageSecs'] * 1000;
            i['turnsWaitAverageSecsSum'] === 0 ? i['turnsWaitAverageSecsSum'] = '-' : i['turnsWaitAverageSecsSum'] = i['turnsWaitAverageSecsSum'];
          });
          o['data']['totalAppTurnsCancelled'] === 0 ? o['data']['totalAppTurnsCancelled'] = '-' : o['data']['totalAppTurnsCancelled'] = o['data']['totalAppTurnsCancelled'];
          o['data']['totalAppTurnsPicked'] === 0 ? o['data']['totalAppTurnsPicked'] = '-' : o['data']['totalAppTurnsPicked'] = o['data']['totalAppTurnsPicked'];
          o['data']['totalSmsTurnsPicked'] === 0 ? o['data']['totalSmsTurnsPicked'] = '-' : o['data']['totalSmsTurnsPicked'] = o['data']['totalSmsTurnsPicked'];
          o['data']['totalTicketTurnsPicked'] === 0 ? o['data']['totalTicketTurnsPicked'] = '-' : o['data']['totalTicketTurnsPicked'] = o['data']['totalTicketTurnsPicked'];
          o['data']['totalTurnsAttended'] === 0 ? o['data']['totalTurnsAttended'] = '-' : o['data']['totalTurnsAttended'] = o['data']['totalTurnsAttended'];
          o['data']['totalTurnsAverageSecs'] === 0 ? o['data']['totalTurnsAverageSecs'] = '-' : o['data']['totalTurnsAverageSecs'] = o['data']['totalTurnsAverageSecs'] * 1000;
          o['data']['totalTurnsBacked'] === 0 ? o['data']['totalTurnsBacked'] = '-' : o['data']['totalTurnsBacked'] = o['data']['totalTurnsBacked'];
          o['data']['totalTurnsCancelled'] === 0 ? o['data']['totalTurnsCancelled'] = '-' : o['data']['totalTurnsCancelled'] = o['data']['totalTurnsCancelled'];
          o['data']['totalTurnsPassed'] === 0 ? o['data']['totalTurnsPassed'] = '-' : o['data']['totalTurnsPassed'] = o['data']['totalTurnsPassed'];
          o['data']['totalTurnsPicked'] === 0 ? o['data']['totalTurnsPicked'] = '-' : o['data']['totalTurnsPicked'] = o['data']['totalTurnsPicked'];
          o['data']['totalSmsSent'] === 0 ? o['data']['totalSmsSent'] = '-' : o['data']['totalSmsSent'] = o['data']['totalSmsSent'];
          o['data']['listTurnStadistics'] = o['data']['listTurnStadistics'].map(
            (s) => {
              return Object.assign(new TurnReportBasic(), s);
            }
          );
          return o;
        })
      );
    }
    return EMPTY;
  }

  public turnsDetailsList(dateTimeFrom, dateTimeTo, centerInternalIdList) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsTurnsDaoService.turnsDetailsList(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        dateTimeFrom,
        dateTimeTo,
        centerInternalIdList
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['turns'])
      );
    }
    return EMPTY;
  }

  public listTurnsPerType(datetimeFrom, datetimeTo, centerInternalIds) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsTurnsDaoService.listTurnsPerType(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimeFrom, datetimeTo, centerInternalIds).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['turnsByMedia'])
      );
    }
    return EMPTY;
  }

  public listTurnsPerDesk(datetimeFrom, datetimeTo, centerInternalIds) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsTurnsDaoService.listTurnsPerDesk(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimeFrom, datetimeTo, centerInternalIds).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['turnsByDeskName']['desksNumbers'])
      );
    }
    return EMPTY;
  }

  public bestDesks(datetimeFrom, datetimeTo, centerInternalIds) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsTurnsDaoService.bestDesks(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimeFrom, datetimeTo, centerInternalIds).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['turnsByDeskName'])
      );
    }
    return EMPTY;
  }

  public getSalesByCenter(datetimeFrom, datetimeTo, authorization) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.dashboardDaoService.getSalesByCenter(datetimeFrom, datetimeTo, this.userStorageService.getLang(), authorization).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['datos'])
      );
    }
    return EMPTY;
  }

  public waitingTimePerDesk(datetimeFrom, datetimeTo, centerInternalIds) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsTurnsDaoService.waitingTimePerDesk(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimeFrom, datetimeTo, centerInternalIds).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['minutesAtHour'])
      );
    }
    return EMPTY;
  }

  public attentionTimePerDesk(datetimeFrom, datetimeTo, centerInternalIds) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.reportsTurnsDaoService.attentionTimePerDesk(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimeFrom, datetimeTo, centerInternalIds).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['minutesAtHour'])
      );
    }
    return EMPTY;
  }

  public rememberForm(filterReportsForm, statusList, showAdvanced) {
    this.filterReportsForm = filterReportsForm;
    this.statusList = statusList;
    this.showAdvanced = showAdvanced;
  }

  public getRememberedForm() {
    return { form: this.filterReportsForm, statusList: this.statusList, showAdvanced: this.showAdvanced };
  }

  public refreshReportsList(assistances) {
    this.refreshReportsListListener.next(assistances);
  }

  public refreshReportsListListen() {
    return this.refreshReportsListListener.asObservable();
  }
}
